<script setup>
import { ref, onBeforeUnmount } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

defineProps({
  tag: { type: String, default: 'div' }
})

const lazyRef = ref()
const visible = ref(false)
const { stop } = useIntersectionObserver(lazyRef, ([{ isIntersecting }]) => {
  visible.value = isIntersecting
  if (visible.value) stop()
})

onBeforeUnmount(() => stop())
</script>

<template>
  <component :is="tag" ref="lazyRef">
    <template v-if="visible"><slot></slot></template>
    <template v-else><slot name="loading"></slot></template>
  </component>
</template>
